import Container from "../lds/Container";
import ColleaguesFeedsTableGroup from "./ColleaguesFeedsTableGroup";

export default function ColleaguesFeedsPanel({ feedMonitors }) {
  const names = Object.keys(feedMonitors);

  // Group by first letter in each name
  const groupedByFirstLetterOfName = {}
  
  names.forEach(name => {
    const firstLetter = name[0].toLocaleUpperCase()
    groupedByFirstLetterOfName[firstLetter] ||= {}
    groupedByFirstLetterOfName[firstLetter][name] = feedMonitors[name]
  })

  const letters = Object.keys(groupedByFirstLetterOfName)

  return (
    <Container className="w-1200 colleagues-feeds-container">
      {letters.map((letter) => (
        <ColleaguesFeedsTableGroup key={letter} letter={letter} feedMonitors={groupedByFirstLetterOfName[letter]} />
      ))}
    </Container>
  );
}

window.ColleaguesFeedsPanel = ColleaguesFeedsPanel;
